import { render, staticRenderFns } from "./Bloco10Coe.vue?vue&type=template&id=386aa47a&scoped=true&"
import script from "./Bloco10Coe.vue?vue&type=script&lang=js&"
export * from "./Bloco10Coe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386aa47a",
  null
  
)

export default component.exports